import React, { useEffect } from 'react';
import { crmAPI } from '../server';
import LogoAncona from '../assets/img/LogoAncona.png';


const NoAceptado: React.FC = () => {

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const telefono = (params.get('phone') ?? '').replace(/\D/g, '');
      const storageKey = `phoneEnviado_${telefono}`;
      if (localStorage.getItem(storageKey)) return;
      localStorage.setItem(storageKey, '1');
      handleTelefonoDetectado(telefono);
    }, []);

    const handleTelefonoDetectado = (telefono: string) => {
      let data = {
        PhoneNumber:telefono,
        Accept:false
      }
      crmAPI.saveRequestFromUrl(data).then(() => {
              
      })
      .catch((err) => {
        console.log(err)
      });
    };

  return (
    <div className="bg-background text-on-background font-body-md min-h-screen flex flex-col">
      <header className="flex items-center w-full px-4 h-16 bg-surface border-b border-outline-variant fixed top-0 z-50 justify-center">
        <img
          src={LogoAncona}
          alt="Ancona Pro Logo"
          className="h-10 w-auto object-contain"
        />
      </header>

      <main className="flex-grow flex flex-col items-center justify-center px-container-margin py-xl relative overflow-hidden">
        <div className="absolute top-0 right-0 -z-10 opacity-5 pointer-events-none">
          <span className="material-symbols-outlined text-[300px]">handshake</span>
        </div>

        <div className="w-full max-w-lg bg-surface border border-outline-variant rounded-xl shadow-lg p-lg text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-primary" />

          <div className="mb-lg flex justify-center">
            <div className="w-24 h-24 rounded-full bg-surface-container-low flex items-center justify-center">
              <span
                className="material-symbols-outlined text-[56px] text-primary"
                style={{ fontVariationSettings: '"FILL" 1' }}
              >
                waving_hand
              </span>
            </div>
          </div>

          <h3 className="text-headline-sm font-headline-sm text-primary mb-md">
            ¡Gracias por tu tiempo!
          </h3>

          <div className="space-y-lg">
            <p className="text-body-lg text-on-surface leading-relaxed">
              Lamentamos que el programa{' '}
              <span className="font-bold text-primary">ANCONA PRO</span> no sea de tu interés
              en este momento.
            </p>

            <div className="bg-surface-container-low rounded-lg p-md text-left border-l-4 border-primary">
              <div className="flex gap-md">
                <span className="material-symbols-outlined text-primary">favorite</span>
                <p className="text-body-md">
                  Las puertas siguen abiertas: cuando quieras activar tu beneficio, estaremos
                  encantados de recibirte.
                </p>
              </div>
            </div>

            <p className="text-body-md text-on-surface-variant">
              Seguimos agradeciendo tu preferencia por Refaccionaria Ancona Autopartes.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NoAceptado;
